import { faCheck } from "@fortawesome/free-solid-svg-icons/faCheck";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { DashboardTodayTaskDto } from "../../../model/dashboard/dto/DashboardTodayTaskDto";
import { useAppDispatch, useAppSelector } from "../../../redux/store";
import { taskActions } from "../../../redux/task/task.slice";
import { userSliceSelectors } from "../../../redux/user/user.selector";
import { TestIDs } from "../../../tests/types/testIds";
import { AtiraToast } from "../../../utils/AtiraToast";
import { standardDate } from "../../../utils/Date";
import {
  DashboardRow,
  DashboardRowAction,
  DashboardRowMeta,
  DashboardRowTag,
  DashboardRowTitle,
  DashboardRowWhat,
} from "./DashboardListRow";

type DashboardTaskRowProps = {
  task: DashboardTodayTaskDto;
  overdue: boolean;
};

export const DashboardTaskRow: React.FC<DashboardTaskRowProps> = ({
  task,
  overdue,
}) => {
  const [loading, setLoading] = useState(false);

  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const user = useAppSelector(userSliceSelectors.selectLoggedInUser)!;
  const userId = useAppSelector(userSliceSelectors.selectLoggedInUserId)!;

  const onMarkDone = async () => {
    try {
      setLoading(true);
      await dispatch(
        taskActions.updateTask({
          userId,
          taskId: task._id,
          done: true,
          kind: task.kind,
        }),
      ).unwrap();
      AtiraToast.success(t("tasks.done.success"));
    } catch (e: any) {
      console.log(e);
      AtiraToast.apiError(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <DashboardRow>
      <DashboardRowTag $tone={overdue ? "danger" : "accent"}>
        {t(
          overdue
            ? "dashboard.today.tag.overdue"
            : "dashboard.today.tag.due_today",
        )}
      </DashboardRowTag>
      <DashboardRowWhat>
        <DashboardRowTitle to="/tasks">{task.name}</DashboardRowTitle>
        <DashboardRowMeta>
          {t("dashboard.today.meta.due", {
            date: standardDate(task.deadline, user, true),
          })}
        </DashboardRowMeta>
      </DashboardRowWhat>
      <DashboardRowAction
        icon={faCheck}
        label={t("dashboard.today.action.mark_done")}
        disabled={loading}
        onClick={onMarkDone}
        dataTestId={TestIDs.dashboard.today.markDone(task._id)}
      />
    </DashboardRow>
  );
};
